

export default global = {
    request:"GET"
}